
import React, { Component } from "react"
import './DocumentsTab.css'
import DocumentList from "./DocumentList"

class DocumentsTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            isArchived: false
        }
    }

    render() {
        const { id, slug, refetchQuery, viewType } = this.props
        return (
            <div className="document-tab-container" style={{ borderTopLeftRadius: "0px" }}>
                <div className="d-flex align-items-center mb-3">
                    <strong>Show Archived</strong>
                    <i
                        className={`fa fa-toggle-${!this.state.isArchived ? "on" : "off"} archive-toggle-icon ${!this.state.isArchived ? "toggle-green" : "toggle-red"}`}
                        onClick={() => this.setState({ isArchived: !this.state.isArchived })}
                    />
                    <strong>Exclude Archived</strong>
                </div>
                <DocumentList
                    id={id}
                    isArchived={this.state.isArchived}
                    slug={slug || null}
                    refetchQuery={refetchQuery || null}
                    viewType={viewType || null}
                />
            </div>
        )
    }
}

export default DocumentsTab
